var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12H22M22 12L18.667 7.99997M22 12L18.667 16M14 6.99997V5.17397C14 4.89735 13.9426 4.62373 13.8314 4.37042C13.7203 4.11711 13.5578 3.88961 13.3542 3.70231C13.1507 3.515 12.9104 3.37196 12.6488 3.28222C12.3871 3.19249 12.1097 3.15801 11.834 3.18097L3.834 3.84697C3.33405 3.88861 2.86801 4.11662 2.5283 4.48578C2.18859 4.85494 2.00002 5.33829 2 5.83997V18.16C2.00002 18.6617 2.18859 19.145 2.5283 19.5142C2.86801 19.8833 3.33405 20.1113 3.834 20.153L11.834 20.82C12.1098 20.8429 12.3873 20.8084 12.649 20.7186C12.9107 20.6288 13.151 20.4857 13.3546 20.2983C13.5582 20.1109 13.7206 19.8833 13.8317 19.6298C13.9428 19.3764 14.0001 19.1027 14 18.826V17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2f6ce01518922757fd39d4347ae3628b.svg";
export { ForwardRef as ReactComponent };